export const CROSS_SIZE = '26px';
export const SIMILAR_PRODUCTS = 'Similar Products';